export const Options = {
  foodChoices: [
    {
      id: "1",
      label: "Gluton free",
      selected: true,
    },
    {
      id: "2",
      label: "Lactose Free",
      selected: true,
    },
    {
      id: "3",
      label: "Non-Veg",
      selected: true,
    },
    {
      id: "4",
      label: "Lacto Veg",
      selected: true,
    },
    {
      id: "5",
      label: "Veg",
      selected: false,
    },
  ],
};

/* export const foodChoices = [
  {
    id: "1",
    label: "Gluton free",
    selected: true,
  },
  {
    id: "2",
    label: "Lactose Free",
    selected: true,
  },
  {
    id: "3",
    label: "Non-Veg",
    selected: true,
  },
  {
    id: "4",
    label: "Lacto Veg",
    selected: true,
  },
  {
    id: "5",
    label: "Veg",
    selected: false,
  },
];
 */
